import { useContext, useEffect, useMemo, useState } from "react";
import { Auth } from "../../StateManagment/Auth.js";
import { useTaskDTO } from "../../hooks/firebase/TaskDto.jsx";
import { CalendarView } from "../../components/calendar/CalendarView.jsx";
import { personaColorById } from "../../helpers/calendar/personaAgendaColors.js";
import { client } from "../../hooks/Client.js";
import { useFirestoreGeneral, useFirestoreGeneralArrayContains } from "../../firebase/useFirestore.js";

const MOBILE_HEADER_TOOLBAR = {
  left: 'prev,next today',
  center: 'title',
  right: 'listWeek,timeGridWeek,timeGridDay',
};

const MobileCalendarUser = () => {
  // Context
  const [auth] = useContext(Auth);

  // State
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [dateRange, setDateRange] = useState({
    start: new Date(),
    end: new Date()
  });

  // Hooks
  const taskDTO = useTaskDTO();

  // Firestore
  // Tasks are assigned to personas (the team picker stores persona IDs), so a
  // logged-in user's tasks live under their linked persona, found via UserID.
  const myPersonas = useFirestoreGeneral("Personas", "UserID", auth?.ID || "");
  const myPersonaId = (Array.isArray(myPersonas) ? myPersonas[0]?.ID : "") || "";

  const tasks = useFirestoreGeneralArrayContains(
    "Tasks",
    "TeamMembers",
    myPersonaId,
  );

  // Eigen agendakleur — hier alleen die van de eigen persona, want dat zijn
  // de enige blokken op deze pagina.
  const personaColors = useMemo(
    () => personaColorById(Array.isArray(myPersonas) ? myPersonas : []),
    [myPersonas]
  );

  return (
    <div className="mobile-page">
      <CalendarView
        docs={tasks || []}
        personaColorById={personaColors}
        userId={auth?.ID}
        onDateRangeChange={setDateRange}
        onStaleData={() => setRefreshCounter((c) => c + 1)}
        contextTitle={"Mijn agenda"}
        contextId={auth?.ID}
        contextType={"teamSchedule"}
        initialview="listWeek"
        headerToolbar={MOBILE_HEADER_TOOLBAR}
      />
    </div>
  );
};

export default MobileCalendarUser;
